import icon from '../../../../assets/icon-01.png';

import $i18n from '../../../../i18n';
export const dataArchived = [
  {
    url: icon,
    title: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseStarbucksMiniapp',
      dm: 'Starbucks miniapp',
    }),
    id: '54351963876891',
    version: 'V1.2.1',
    creator: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseJasonCharlie',
      dm: 'Jason Charlie',
    }),
    modified: '2022-08-23  21:20:16',
    status: 'Released',
  },
  {
    url: icon,
    title: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseStarbucksMiniapp',
      dm: 'Starbucks miniapp',
    }),
    id: '54351963876892',
    version: 'V1.2.1',
    creator: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseJasonCharlie',
      dm: 'Jason Charlie',
    }),
    modified: '2022-08-23  21:20:16',
    status: 'Version Created',
  },
  {
    url: icon,
    title: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseStarbucksMiniapp',
      dm: 'Starbucks miniapp',
    }),
    id: '54351963876893',
    version: 'V1.2.1',
    creator: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseJasonCharlie',
      dm: 'Jason Charlie',
    }),
    modified: '2022-08-23  21:20:16',
    status: 'Under Review',
  },
  {
    url: icon,
    title: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseStarbucksMiniapp',
      dm: 'Starbucks miniapp',
    }),
    id: '54351963876894',
    version: 'V1.2.1',
    creator: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseJasonCharlie',
      dm: 'Jason Charlie',
    }),
    modified: '2022-08-23  21:20:16',
    status: 'Gray Released',
  },
  {
    url: icon,
    title: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseStarbucksMiniapp',
      dm: 'Starbucks miniapp',
    }),
    id: '54351963876895',
    version: 'V1.2.1',
    creator: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseJasonCharlie',
      dm: 'Jason Charlie',
    }),
    modified: '2022-08-23  21:20:16',
    status: 'Released',
  },
  {
    url: icon,
    title: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseStarbucksMiniapp',
      dm: 'Starbucks miniapp',
    }),
    id: '54351963876896',
    version: 'V1.2.1',
    creator: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseJasonCharlie',
      dm: 'Jason Charlie',
    }),
    modified: '2022-08-23  21:20:16',
    status: 'Released',
  },
  {
    url: icon,
    title: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseStarbucksMiniapp',
      dm: 'Starbucks miniapp',
    }),
    id: '54351963876897',
    version: 'V1.2.1',
    creator: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseJasonCharlie',
      dm: 'Jason Charlie',
    }),
    modified: '2022-08-23  21:20:16',
    status: 'Released',
  },
  {
    url: icon,
    title: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseStarbucksMiniapp',
      dm: 'Starbucks miniapp',
    }),
    id: '54351963876898',
    version: 'V1.2.1',
    creator: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseJasonCharlie',
      dm: 'Jason Charlie',
    }),
    modified: '2022-08-23  21:20:16',
    status: 'Released',
  },
  {
    url: icon,
    title: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseStarbucksMiniapp',
      dm: 'Starbucks miniapp',
    }),
    id: '54351963876899',
    version: 'V1.2.1',
    creator: $i18n.get({
      id: 'aopf.component.archived.dataArchived.ChineseJasonCharlie',
      dm: 'Jason Charlie',
    }),
    modified: '2022-08-23  21:20:16',
    status: 'Released',
  },
];
